import { createTheme } from "@mui/material/styles";
import { Dimensions, StyleSheet } from "react-native";

export const THEME_COLORS = {
  primary: "#242a52",
  primaryPurple: "rgba(99, 0, 163, 0.6)",
  black: "black",
  black2: "#333",
  white: "#fff",
  border1: "#ddd",
  pink: "#ff667a",
  lightPink: "#fff7f0",
  border2: "#eee",
  red: "#ed264f",
  green: "#21cc9e",
  green2: "#0BA300",
  orange: "#ff9a3d",
  red2: "rgb(255,119,119)",
  red3: "rgb(255,189,169)",
  bgWhite: "#F2F2F2",
  shadow1: "rgba(0, 0, 0, 0.08)",
  disabledInputBG: "#eee",
  shadow2: "rgba(0, 0, 0, 0.5)",
  shadow3: "rgba(0, 0, 0, 0.4)",
  shadow4: "rgba(0, 0, 0, 0.3)",
  grey0: "#adadad",
  grey1: "#e5e5e5",
  grey2: "#f8f7ff",
  selectedPink: "#fff0f0",
  grey3: "#e6e6e6",
  textGrey: "#808080",
  sideMenuGrey: "#7D7D7D",
  success: "#13b54b",
  redAlert: "#f25278",
  warning: "#fb8c00",
  excelGreen: "#1d6f42",
  hyperlink: "blue",
  purple: "#6300A3",
  sideMenuActiveBg: "#EDE9F0",
  sideMenuBg: "#f7f3fa",
  purple2: "#AD79CF",
  purple3: "#E8DAF2",
  chartIndigo: "#9AB7DF",
  chartPink: "#E28F99",
  chartYellow: "#EDA97D",
  chartRed: "#D5545F",
  startPending: "#E36000",
  statusWIP: "#3E7DC3",
  statusTechPending: "#F9D042",
  sideMenuV3ActiveBg: "#c0b4cb",
  sideMenuBgV3: "#e7daf1",
  cgtScore: "#009962",
  tableArrow: "#2E054E",
  brightRed: "#F44336",
  coal: "#303030",
  light_purple: "#EFE5F6",
  grey_55: "#555555",
  grey_E8: "#E8E8E8",
  grey_F9: "#F9FAFB",
  grey_71: "#717171",
  grey_F1: "#F1F1F1",
  lightPurple: "#F7F2FA",
  black_14: "#141414",
  grey_CA: "#CACACA",
  red1: "#CD2C39",
  grey_D9: "#D9D9D9",
  purple_shade: "#E0CCED",
  dark_purple: "#8233B5",
  black16: "#161616",
  orangeBD: "#BD5000"
};
export const FONT_FAMILY = {
  primary: "FuturaPTDemi",
  one: "FuturaPTLight",
  two: "FuturaPTBook",
  three: "FuturaPTMedium",
  four: "FuturaPTDemi",
  five: "FuturaPTBold",
  primaryV3: "NotoSans",
  boldV3: "NotoSansBold",
  mediumV3: "NotoSansMedium",
  semiBoldV3: "NotoSansSemiBold",
  thinV3: "NotoSansThin",
};

export const FONT_SIZE = {
  s0: "10px",
  s1: "14px",
  s2: "16px",
  s3: "18px",
  s4: "22px",
  logoFontSize: "1.5rem",
  tabFontSize: "1.2rem",
  subTabFontSize: "0.8em",
};
export const OTHER_CONSTANTS = {
  inputHeight: "30px",
  selectInputHeight: "28px",
};
export const symbols = {
  rupee: "₹",
};
// export const FONT_SIZE = {s1: '2.2vh', s2: '2vh'};
// export const OTHER_CONSTANTS = {inputHeight: '4vh', selectInputHeight: '3.9vh'};
export const commonStyles = StyleSheet.create({
  themeColor: {
    backgroundColor: THEME_COLORS.primary,
  },
  loginView: {
    justifyContent: "center",
    alignItems: "center",
    height: Dimensions.get("window").height - 200,
  },
  inputWidthHeight: {
    minWidth: 400,
    height: 50,
    padding: 5,
    marginTop: 10,
    marginBottom: 10,
  },
  robotoFont: {
    fontFamily: FONT_FAMILY.primary,
  },
  input: {
    backgroundColor: THEME_COLORS.white,
    borderRadius: 10,
    borderColor: THEME_COLORS.border1,
    borderWidth: 1,
    shadowColor: THEME_COLORS.shadow1,
    shadowRadius: 4,
    shadowOpacity: 1,
    fontFamily: FONT_FAMILY.primary,
    paddingLeft: 5,
    fontSize: FONT_SIZE.s2,
    height: OTHER_CONSTANTS.inputHeight,
  },
  input2: {
    backgroundColor: THEME_COLORS.white,
    borderRadius: 25,
    borderColor: THEME_COLORS.border1,
    borderWidth: 1,
    shadowColor: THEME_COLORS.shadow1,
    shadowRadius: 4,
    shadowOpacity: 1,
    fontFamily: FONT_FAMILY.primary,
    paddingLeft: 5,
    fontSize: FONT_SIZE.s2,
    height: OTHER_CONSTANTS.inputHeight,
  },
  input3: {
    backgroundColor: THEME_COLORS.white,
    borderBottomColor: THEME_COLORS.border1,
    borderBottomWidth: 1,
    fontFamily: FONT_FAMILY.primary,
    paddingLeft: 5,
    fontSize: FONT_SIZE.s2,
    height: OTHER_CONSTANTS.inputHeight,
  },
  disabledInput: {
    backgroundColor: THEME_COLORS.disabledInputBG,
  },
  center: {
    justifyContent: "center",
    alignItems: "center",
    shadowColor: THEME_COLORS.shadow1,
    shadowRadius: 4,
    shadowOpacity: 1,
  },
  actionButton: {
    borderRadius: 10,
    padding: 12,
  },
  actionButtonText: {
    color: THEME_COLORS.white,
  },
  cardOne: {
    flex: 1,
    flexDirection: "row",
    backgroundColor: "#EAEAEA",
    padding: 7,
    margin: 10,
    borderRadius: 14,
    shadowColor: "rgba(119, 119, 119, 1)",
    shadowRadius: 4,
    shadowOpacity: 1,
  },
  customSelect: {
    minWidth: 200,
    backgroundColor: THEME_COLORS.grey2,
    borderRadius: 8,
    padding: 8,
  },
});

export const images = {
  dashboardIcon: require("../assets/dashboard_icon.png"),
  userIcon: require("../assets/user.png"),
  notificationIcon: require("../assets/notification.png"),
  invoiceIcon: require("../assets/invoice.png"),
  issueIcon: require("../assets/issueIcon.png"),
  timeline2: require("../assets/timeline2.png"),
  jobListIcon: require("../assets/joblist_icon.png"),
  carIcon: require("../assets/car.png"),
  vendorsIcon: require("../assets/vendors.png"),
  leftCheronWhite: require("../assets/path_2.png"),
  vocIcon: require("../assets/voice_of_customer.png"),
  backgroundImage: require("../assets/bg.png"),
  googleIcon: require("../assets/google.png"),
  errorIcon: require("../assets/error.png"),
  roundedCheck: require("../assets/rounded_tick.png"),
  chevronDown: require("../assets/chevron_down.png"),
  searchIcon: require("../assets/search_icon.png"),
  removeIcon: require("../assets/remove.png"),
  addIcon: require("../assets/add.png"),
  sadIcon: require("../assets/sad_face.png"),
  moreIcon: require("../assets/more.png"),
  addCircleIcon: require("../assets/add_circle.png"),
  alertIcon: require("../assets/alert.png"),
  adjustIcon: require("../assets/adjust.png"),
  checkedIcon: require("../assets/selected.png"),
  unCheckedIcon: require("../assets/unselected.png"),
  squareCheckIcon: require("../assets/square_check.png"),
  squareCheckedIcon: require("../assets/square_checked.png"),
  plusIcon: require("../assets/plus.png"),
  minusIcon: require("../assets/minus.png"),
  chevronUp: require("../assets/chevron_up.png"),
  crossIcon: require("../assets/close.png"),
  backIcon: require("../assets/back.png"),
  deleteIcon: require("../assets/delete.png"),
  downloadIcon: require("../assets/download.png"),
  viewIcon: require("../assets/view.png"),
  downloadPdfIcon: require("../assets/downloadPdfIcon.png"),
  downloadPdfIconTwo: require("../assets/download_pdf.png"),
  editIcon: require("../assets/editIcon.jpeg"),
  sortIcon: require("../assets/sort.png"),
  sortDownIcon: require("../assets/sort-down.png"),
  sortUpIcon: require("../assets/sort-up.png"),
  replaceIcon: require("../assets/replace.png"),
  receiveAllPartsIcon: require("../assets/receive_parts.png"),
  confirmQuantityIcon: require("../assets/confirm_quantity_icon.png"),
  downloadTwoIcon: require("../assets/download_icon.png"),
  reloadIcon: require("../assets/reload_icon.png"),
  pointIcon: require("../assets/point.png"),
  tickIcon: require("../assets/tick.png"),
  deleteTwo: require("../assets/delete_two.png"),
  imagePlaceholderIcon: require("../assets/image_placeholder.png"),
  verifiedIcon: require("../assets/verified_icon.png"),
  fileIcon: require("../assets/fileUpload.png"),
  timeline: require("../assets/timeline.png"),

  //Side Menu Icons
  sideMenuCar: require("../assets/sideMenu/car.svg"),
  sideMenuInventory: require("../assets/sideMenu/inventory.svg"),
  sideMenuJoblist: require("../assets/sideMenu/joblist.svg"),
  sideMenuInvoice: require("../assets/sideMenu/invoice.svg"),
  sideMenuCreateInvoice: require("../assets/sideMenu/createInvoice.svg"),
  sideMenu360View: require("../assets/sideMenu/three_sixty.svg"),
  sideMenuVendors: require("../assets/sideMenu/vendors.svg"),
  sideMenuJobcard: require("../assets/sideMenu/jobcards.svg"),
  sideMenuSpareParts: require("../assets/sideMenu/spare_parts.svg"),
  tableArrow: require("../assets/table-arrow.svg"),
  infoIcon: require("../assets/info_icon.png"),
  arrowRight: require("../assets/arrow_right.png"),
  partName: require("../assets/partName.png"),
};

export const muiTheme = createTheme({
  palette: {
    primary: {
      main: THEME_COLORS.purple,
    },
    secondary: {
      main: THEME_COLORS.sideMenuBg,
    },
  },
  typography: {
    fontFamily: FONT_FAMILY.primaryV3,
  },

  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: "0.9em",
          color: "#6300A3",
          fontFamily: FONT_FAMILY.four,
          backgroundColor: "#f7f3fa",
          padding: "0.5em 1em",
          borderRadius: "0.3em",
          zIndex: 9999999,
        },
        popper: {
          // zoom: 0.9,
          zIndex: 9999999,
        },
        arrow: {
          color: "#f7f3fa",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          // zoom: "0.9",
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        thumb: {
          size: 10,
          color: "white",
        },
        track: {
          color: "white",
        },
        rail: {
          color: "#9F9F9F",
        },
      },
    },
  },
});

export const STRINGS = {
  notAuthorized: "not authorized",
};

export const scrollStyle = StyleSheet.create({
  customScroll: {},
});

export default commonStyles;
